'use client';

import { VerticalTabs } from '@cc-shopping/ui/composites/VerticalTabs';
import { CdnImage } from '@cc-shopping/ui/primitives/CdnImage';
import { Typography } from '@mui/material';
import type { ReactNode } from 'react';

export type AskOurExpertsDesktopProps = {
  question?: string | null;
  experts: { name: string; avatarUrl?: string | null }[];
  renderedContents: ReactNode[];
};

export function AskOurExpertsDesktop({
  question,
  experts,
  renderedContents,
}: AskOurExpertsDesktopProps) {
  return (
    <VerticalTabs
      labelProps={experts}
      LabelComponent={LabelComponent}
      contentProps={renderedContents.map(content => ({ question, renderedContent: content }))}
      ContentComponent={ContentComponent}
      containerProps={{ sx: { position: 'relative' } }}
    />
  );
}

const LabelComponent = ({ name, avatarUrl }: { name: string; avatarUrl?: string | null }) => {
  return (
    <>
      {avatarUrl && (
        <CdnImage
          width={48}
          height={48}
          style={{ alignSelf: 'center', marginRight: '16px', borderRadius: '50%' }}
          src={avatarUrl}
          alt={`${name} avatar`}
        />
      )}
      <Typography variant="smallHeadline" sx={{ alignSelf: 'center' }}>
        {name}
      </Typography>
    </>
  );
};

const ContentComponent = ({
  question,
  renderedContent,
}: {
  question?: string | null;
  renderedContent: ReactNode;
}) => {
  return (
    <>
      {question && <Typography fontWeight="bold">{question}</Typography>}
      {renderedContent}
    </>
  );
};
